import React, { Component } from 'react'
import PropTypes from 'prop-types'
import {
  Loader as SemanticLoader,
  Dimmer as SemanticDimmer,
} from 'semantic-ui-react'
import classnames from 'classnames/bind'
import styles from './styles.scss'
const cx = classnames.bind(styles)

class Loader extends Component {
  static propTypes = {
    ...SemanticLoader.propTypes,
    dimmer: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
    children: PropTypes.node,
    elmId: PropTypes.string,
  }

  static defaultProps = {
    ...SemanticLoader.defaultProps,
    children: null,
    elmId: null,
  }

  render() {
    const { active, inverted, dimmer, children, elmId, ...rest } = this.props
    return (
      <SemanticDimmer
        {...dimmer}
        active={active}
        inverted={inverted}
        className={cx('dimmer')}
      >
        <SemanticLoader
          {...rest} // rest comes first, so we overwrite any default props with ours
          active={active}
          inverted={inverted}
          data-elm-id={elmId}
        >
          {children}
        </SemanticLoader>
      </SemanticDimmer>
    )
  }
}

export default Loader
